import * as React from "react";

import { useMyBagPresentationModel } from "../providers";

export const MyBagHasItemsPortal: React.FunctionComponent = (props) => {
  const { presentationMyBagItems } = useMyBagPresentationModel();

  const shouldPresent = React.useMemo(() => {
    return presentationMyBagItems.length > 0;
  }, [presentationMyBagItems]);

  if (!shouldPresent) {
    return null;
  }

  return <React.Fragment>{props.children || []}</React.Fragment>;
};
